// router.js
import Vue from 'vue';
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics'
const Homepage = () => import(/* webpackChunkName: "Home" */'../components/Homepage.vue');
const CheckoutProcessing = () => import(/* webpackChunkName: "CheckoutProcessing" */'../components/CheckoutProcessing.vue');
const OrderConfirmation = () => import(/* webpackChunkName: "OrderConfirmation" */'../components/OrderConfirmation.vue');
const OrderFailed = () => import(/* webpackChunkName: "OrderFailed" */'../components/OrderFailed.vue');
//import Home from '../components/Home.vue';
//import About from '../components/About.vue';

Vue.use(Router);

export function createRouter () {
  var router = new Router({
    mode: 'history',
    routes: [
      	{
      		path: '/aktivoi/',
      		name: 'homepage',
      		component: Homepage
      	},
        {
          path: '/aktivoi/checkout-processing/:imei/',
          name: 'checkoutProcessing',
          component: CheckoutProcessing
        },
        {
          path: '/aktivoi/vahvistus/:imei/',
          name: 'orderConfirmation',
          component: OrderConfirmation
        },
        {
          path: '/aktivoi/virhe/:imei/',
          name: 'orderFailed',
          component: OrderFailed
        }
    ],
    scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
  });

  return router;
}

// /aktivoi



// WEBPACK FOOTER //
// ./src/router/router.js